export default "__VITE_ASSET__D6l0znFP__"